import { tokens } from "@fluentui/react-components";
import { useAtomValue } from "jotai";
import { devices } from "library/constants";
import { formatNumber } from "library/utils";
import { useCalculatedBenefitCosts } from "pages/Dashboard/hooks/useCalculatedBenefitCosts";
import { useTranslation } from "react-i18next";
import { selectedBenefitCurrencyAtom } from "store/index";
import styled, { useTheme } from "styled-components";

import { PaymentsCard } from "./PaymentsCard";
import { PaymentsPerCategory } from "./PaymentsPerCategory";

import { TreeMapCard } from "../TreeMap/TreeMapCard";

export function TotalInfoAndCategoryChart() {
  const { t } = useTranslation();
  const theme = useTheme();

  const selectedCurrency = useAtomValue(selectedBenefitCurrencyAtom);

  const { totalBenefitsCost, totalCompanyCost, totalEmployeeWithDependentsCost } =
    useCalculatedBenefitCosts();

  const totalData = [totalCompanyCost, totalEmployeeWithDependentsCost, totalBenefitsCost];

  return (
    <Container>
      <ContentWrap>
        <FirstSection>
          <CardsWrap>
            <PaymentsCard
              title={t("hbh.totalBenefits.label")}
              value={formatNumber(totalBenefitsCost?.size).split(".")[0]}
              decimalValue={formatNumber(totalBenefitsCost?.size).split(".")[1]}
              currency={totalBenefitsCost.currency}
              infoContent=""
            />
            <PaymentsCard
              title={t("hbh.employeeWithDependents.label")}
              value={formatNumber(totalEmployeeWithDependentsCost?.size).split(".")[0]}
              decimalValue={formatNumber(totalEmployeeWithDependentsCost?.size).split(".")[1]}
              currency={totalEmployeeWithDependentsCost.currency}
              infoContent=""
            />
          </CardsWrap>
          <PaymentsPerCategory />
        </FirstSection>
        <div
          style={{
            margin: "0 auto",
          }}
        >
          <TreeMapCard
            name={`${t("hbh.financial.label")} (${selectedCurrency})`}
            data={totalData}
            fill={tokens.colorStatusDangerBackground2}
          />
        </div>
      </ContentWrap>
    </Container>
  );
}

const Container = styled.div``;

const ContentWrap = styled.div`
  display: grid;
  gap: 10px;
  grid-template-columns: 1fr;
  justify-content: center;
  @media only screen and ${devices.md} {
    grid-template-columns: 2fr 1fr;
  }
`;
const FirstSection = styled.div`
  display: grid;
  grid-template-rows: 1fr;
  gap: 10px;
  @media only screen and ${devices.md} {
    grid-template-rows: 136px 1fr;
  }
`;

const CardsWrap = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  @media only screen and ${devices.md} {
    grid-template-columns: 1fr 1fr;
  }
`;
